module.exports = __webpack_public_path__ + "static/media/lb_03 (3).961a27c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb_03 (3).jpg
// module id = 2006
// module chunks = 2